import { __assign } from "tslib";
// DS: CR01F
import React, { useCallback, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import CommissionViewer from '../../../DaEditorWrapper/Viewer/Commission';
import TextRenderer from '../../../TextRenderer';
import { DeviationLink } from '../../../Duperbrowse';
import OrderCommissionButton from '../../../ActionBar/buttons/OrderCommissionButton';
import { getCoverImageAttributes } from '../../Thumb/helpers';
import FeedCardLayout from '../_partials/FeedCardLayout';
import FeedCardTitle from '../_partials/FeedCardTitle';
import { DEFAULT_COVER_IMAGE_RESOLUTION_WIDTH, DEFAULT_COVER_IMAGE_RESOLUTION_HEIGHT, } from '../constants';
import draftTheme from '../../../DaEditorWrapper/Themes/Viewer/feedcard.scss';
import legacyTheme from '../feedcard.legacy.theme.scss';
import expandableWrapperStyles from '../_partials/ExpandableWrapper/ExpandableWrapper.scss';
import s from './Commission.scss';
// commission is especially tall because of it's special cover image
var COLLAPSED_CONTENT_HEIGHT = 480;
var COVER_DOM_HEIGHT_DESKTOP = 280;
var COVER_DOM_HEIGHT_MOBILE = 295;
var CommissionFeedCardContents = function (_a) {
    var _b, _c;
    var className = _a.className, deviation = _a.deviation, extraActions = _a.extraActions, withWatchOrSubscribeButton = _a.withWatchOrSubscribeButton;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var coverImage = getCoverImageAttributes({
        deviation: deviation,
        width: DEFAULT_COVER_IMAGE_RESOLUTION_WIDTH,
        height: DEFAULT_COVER_IMAGE_RESOLUTION_HEIGHT,
        allowHuge: true,
    });
    var coverImageDomHeight = isMobile
        ? COVER_DOM_HEIGHT_MOBILE
        : COVER_DOM_HEIGHT_DESKTOP;
    // maintain this so we can track when we can enable scroll restoration on duperbrowse
    var _d = useState(false), isLayoutReady = _d[0], setIsLayoutReady = _d[1];
    var onLayoutReady = useCallback(function () {
        setIsLayoutReady(true);
    }, []);
    return (React.createElement(FeedCardLayout, { className: className, deviation: deviation, extraActions: extraActions, isExpandable: true, withCommentControl: false, withWatchOrSubscribeButton: withWatchOrSubscribeButton, collapsedContentHeight: COLLAPSED_CONTENT_HEIGHT, 
        // special order button for special commission special case
        additionalActionbarActions: React.createElement("div", { className: s['order-info'] },
            React.createElement("span", { className: s['price'] },
                "$", (_b = deviation.commission) === null || _b === void 0 ? void 0 :
                _b.dollarsCost),
            React.createElement(OrderCommissionButton, { deviation: deviation })), 
        // special mobile expansion button to navigate to special commission on mobile :|
        expansionButton: isMobile ? (React.createElement(DeviationLink, { className: classnames(s['toggle-button'], expandableWrapperStyles['toggle-button']), deviation: deviation, disableScrollRestoration: !isLayoutReady },
            React.createElement("span", { className: expandableWrapperStyles['toggle-button-contents'] }, t('deviationview.feed.readmore')))) : null, onLayoutReady: onLayoutReady },
        coverImage && (React.createElement("div", { className: s['cover-image'], style: { height: coverImageDomHeight } },
            React.createElement("div", __assign({ className: s['blurred-bg-image'] }, coverImage)),
            React.createElement("div", { className: s['fade'] }),
            React.createElement("div", __assign({ className: s['foreground-image'] }, coverImage)))),
        React.createElement("div", { className: s['title-and-price'] },
            React.createElement(FeedCardTitle, { className: s['title'], deviation: deviation, disableScrollRestoration: !isLayoutReady }),
            React.createElement("span", { className: s['price'] },
                "$", (_c = deviation.commission) === null || _c === void 0 ? void 0 :
                _c.dollarsCost)),
        deviation.textContent.excerpt.trim().length > 0 && (React.createElement(TextRenderer, { textContent: deviation.textContent, reactViewer: CommissionViewer, viewerKey: deviation.deviationId, legacyTheme: "commission", fixedParagraph: false, disableLazyLoading: true, draftjsThemeOverride: draftTheme, className: classnames(s['content'], legacyTheme['legacy'], legacyTheme['override'], draftTheme['override'], draftTheme['commission']) }))));
};
CommissionFeedCardContents.displayName = 'CommissionFeedCardContents';
export default CommissionFeedCardContents;
//# sourceMappingURL=Commission.js.map